<template>
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="col-md-8 text-center">
        <div class="error-template">
          <h1 class="display-1 fw-bold text-danger">404</h1>
          <h2 class="display-4 mb-4">Oops! Page Not Found</h2>
          <div class="error-details mb-4">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </div>
          <div class="error-actions">
            <button @click="goToLinkCurt" class="btn btn-primary btn-lg me-3">
              <i class="bi bi-house-door me-2"></i>
              Go to LinkCurt
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404Component',
  /**
   * Navigates the user to a specific route based on the existence of an 'id' in session storage.
   * If an 'id' is found, the user is redirected to the '/links' route.
   * Otherwise, the user is redirected to the '/' route.
   */
  methods: {
    /**
     * Redirects the user to a specific route based on the presence of an "id" in the session storage.
     * If an "id" exists, navigates to the '/links' route. Otherwise, navigates to the root '/' route.
     *
     * @return {void} Does not return a value.
     */
    goToLinkCurt() {
      const id = sessionStorage.getItem('id');
      if (id) {
        this.$router.push('/links');
      } else {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.error-template {
  padding: 15px 15px;
}

.error-actions {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
